/**
 * @generated SignedSource<<b7b471088ac54f8ba4786dc71d0ee9d4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardContentOld_Inner_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BoardColumnOld_query">;
  readonly " $fragmentType": "BoardContentOld_Inner_query";
};
export type BoardContentOld_Inner_query$key = {
  readonly " $data"?: BoardContentOld_Inner_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardContentOld_Inner_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardContentOld_Inner_query",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BoardColumnOld_query"
    }
  ],
  "type": "Query"
};

(node as any).hash = "e04e546914486bfffb8776e25e616ff5";

export default node;
